import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'

import { withRtl } from '../hoc';
import style from './Checkbox.scss';
import { ICONS } from '../Map';

/* eslint-disable jsx-a11y/label-has-for */
class Checkbox extends PureComponent {
  static propTypes = {
    checked: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    disabledForSavedPrograms: PropTypes.bool,
    helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    ariaLabel: PropTypes.string,
    icon: PropTypes.string,
  };

  static defaultProps = {
    disabled: false,
    disabledForSavedPrograms: false,
    helpText: null,
    ariaLabel: '',
    icon: null,
  };

  render() {
    const { checked, id, onChange, disabledForSavedPrograms, value, label, disabled, helpText, ariaLabel, icon } = this.props;
    let isChecked = false;
    if (disabledForSavedPrograms) {
      isChecked = checked
    }
    else {
      isChecked = !disabled && checked
    }
    return (
      <div className={style.outerWrap}>
        <div className={style.wrap}>
          <input
            checked={isChecked}
            className={style.checkbox}
            id={id}
            onChange={onChange}
            type="checkbox"
            value={value}
            disabled={disabled}
          />
          {icon && ICONS && ICONS[icon] && <img src={ICONS[icon].url} className={style.filterIcon} alt={label} />}
          <label className={style.label} htmlFor={id} aria-label={ariaLabel || label}>
            {label}
          </label>
        </div>
        {helpText && <div className={style.helpText}>{helpText}</div>}
      </div>
    );
  }
}

export { Checkbox };
export default withRtl(style)(withStyles(style)(Checkbox));
